<template>
    <modal :name="name"
           :pivotY="0.3"
           :width="600"
           height="auto"
           clickToClose
           @opened="opened"
           @before-open="beforeOpen"
           @before-close="beforeClose">

        <div :id="name" tabindex="-1" class="modal-container container py-4 px-5 h-100">

            <h3 class="app-modal-header text-center">
                Update payment method
            </h3>

            <form @submit.prevent="save" id="payment-form" class="app-modal-content" style="min-height:0px;">
                <div class="row text-left justify-content-center">

                    <!--<div class="col-12 text-left form-group">-->
                    <!--<label for="cardName">Card name</label>-->
                    <!--<input v-model.trim="cardName"-->
                    <!--@input="vuelidateDelayTouch($v.cardName, touchMap)"-->
                    <!--autofocus-->
                    <!--type="text"-->
                    <!--id="cardName"-->
                    <!--class="form-control"-->
                    <!--placeholder="Card name">-->
                    <!--<small v-if="$v.cardName.$error" class="form-text text-danger">-->
                    <!--<span v-if="!$v.cardName.required">This field is required</span>-->
                    <!--</small>-->
                    <!--</div>-->

                    <!-- STRIPE ELEMENTS -->
                    <div class="col-12 form-group mt-3">
                        <div id="card-element">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>
                    </div>
                    <div class="col-12 form-group">
                        <!-- Used to display form errors. -->
                        <div id="card-errors" role="alert"></div>
                    </div>
                </div>
            </form>

            <div class="app-modal-actions mt-0">
                <div class="row justify-content-end">
                    <button @click="$modal.hide(name)" class="btn btn-link mt-3">Close</button>
                    <button v-loading.btn="isLoading" @click="save" class="btn btn-primary">
                        Update
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
// Test data:
// 4242 4242 4242 4242
// Future expire date, random cvc

import axios from 'axios'
import {mapActions, mapGetters} from 'vuex'
import {BILLING_INFO_FETCH} from '../../../../store/modules/billing'
import {Env} from '../../../../../env'

export default {
    name: 'EditBillingCard',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            touchMap: new WeakMap(),

            stripe: null,
            stripeToken: null,
            cardNumberEl: null,

            // cardName: '',
            isLoading: false,

            plan: 'bbb'
        }
    },
    validations: {
        // cardName: {required}
    },
    computed: {
        ...mapGetters('billing', [
            'billingInfo'
        ])
    },
    methods: {
        ...mapActions('billing', {
            fetchBillingInfo: BILLING_INFO_FETCH
        }),

        beforeOpen() {
            if (this.billingInfo.card && this.billingInfo.card.name) {
                this.cardName = this.billingInfo.card.name
            }
        },

        beforeClose() {
            this.cardName = ''
            this.$v.$reset()
        },

        opened() {
            this.stripe = Stripe(Env.stripeKey)
            let elements = this.stripe.elements()

            let style = {
                base: {
                    fontFamily: 'Lato, Helvetica, Arial, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#6c757d'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            }

            this.card = elements.create('card', {style})
            this.card.mount('#card-element')
            this.card.addEventListener('change', this.onCardDataChange)

            // const form = document.getElementById('payment-form')
            // form.addEventListener('submit', this.onStripeFormSubmit)
        },

        // onStripeFormSubmit(event) {
        //     alert('Submit')
        //     event.preventDefault()
        //     this.stripe.createToken(this.card).then(result => {
        //         if (result.error) {
        //             // Inform the user if there was an error.
        //             const errorElement = document.getElementById('card-errors')
        //             errorElement.textContent = result.error.message
        //         } else {
        //             // Send the token to your server.
        //             this.stripeTokenHandler(result.token)
        //         }
        //     })
        // },

        onCardDataChange(event) {
            // Handle real-time validation errors from the card Element.
            const displayError = document.getElementById('card-errors')
            if (event.error) {
                displayError.textContent = event.error.message
            } else {
                displayError.textContent = ''
            }
        },

        // Submit the form with the token ID.
        stripeTokenHandler(token) {
            // Insert the token ID into the form so it gets submitted to the server
            const form = document.getElementById('payment-form')
            const hiddenInput = document.createElement('input')
            hiddenInput.setAttribute('type', 'hidden')
            hiddenInput.setAttribute('name', 'stripeToken')
            hiddenInput.setAttribute('value', token.id)
            form.appendChild(hiddenInput)
            form.submit()
        },

        save() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            this.isLoading = true
            // The card number pulls data from other Elements
            // created on the same instance of elements to tokenize (expire date, cvc).

            let self = this

            this.stripe.createPaymentMethod({
                type: 'card',
                card: this.card
            }).then(function(result) {
                if (result.error) {
                    // Display result.error.message in UI
                    throw new Error(result.error)
                } else {
                    // The PaymentMethod has successfully
                    // been created
                    let data = {
                        plan: self.plan,
                        token: result.paymentMethod.id
                    }
                    return axios.post('teams/billing/payment', data)
                }
            }).then(() => {
                this.fetchBillingInfo()
                this.$modal.hide(this.name)
            }).catch(() => {
                this.$snackbar.show({type: 'ERROR', text: 'Update card data error'})
            }).finally(() => {
                this.isLoading = false
            })

            // this.stripe.createToken(this.card)
            //     .then(({token, error}) => {
            //         if (error) {
            //             throw new Error(error)
            //         }
            //         return axios.post('teams/billing/payment', {
            //             cardName: this.cardName,
            //             token: token.id,
            //             plan: 'bbb'
            //         })
            //     })
            //     .then(() => {
            //         this.fetchBillingInfo()
            //         this.$modal.hide(this.name)
            //     })
            //     .catch(() => {
            //         this.$snackbar.show({type: 'ERROR', text: 'Update card data error'})
            //     })
            //     .finally(() => {
            //         this.isLoading = false
            //     })
        }
    }
}
</script>

<style scoped>
button {
    width: 120px;
}
</style>

<style scoped>
.StripeElement {
    padding: 8px 12px;
    display: block;
    width: 100%;
    height: calc(2.25rem + 2px);
    /*font-size: 1rem;*/
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
}

.StripeElement--focus {
    /*box-shadow: 0 1px 3px 0 #cfd7df;*/
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}
</style>

<!--
// (Separated)

        <div class="col-12 form-group">
            <label for="card-number-el">Card number</label>
            <div ref="card-number-el" id="card-number-el"></div>
            <small ref="card-number-errors" class="text-danger" role="alert"></small>
        </div>

        <div class="col-6 form-group">
            <label for="card-expiry-el">Expiry Date</label>
            <div ref="card-expiry-el" id="card-expiry-el"></div>
            <small ref="card-expiry-errors" class="text-danger" role="alert"></small>
        </div>

        <div class="col-6 form-group">
            <label for="card-cvc-el">Card CVC</label>
            <div ref="card-cvc-el" id="card-cvc-el"></div>
            <small ref="card-cvc-errors" class="text-danger" role="alert"></small>
        </div>

                // CARD NUMBER
                // let cardNumberRef = this.$refs['card-number-el']
                // let cardNumber = elements.create('cardNumber', {
                //     style: style,
                //     placeholder: 'Credit card number'
                // })
                // cardNumber.mount(cardNumberRef)
                // cardNumber.addEventListener('change', event => {
                //     this.$refs['card-number-errors'].textContent = event.error ? event.error.message : ''
                // })
                // this.cardNumberEl = cardNumber // element to tokenize
                //
                // // CARD EXPIRE DATE
                // let cardExpiryRef = this.$refs['card-expiry-el']
                // let cardExpiry = elements.create('cardExpiry', {
                //     style: style,
                //     placeholder: 'Expiry date'
                // })
                // cardExpiry.mount(cardExpiryRef)
                // cardExpiry.addEventListener('change', event => {
                //     this.$refs['card-expiry-errors'].textContent = event.error ? event.error.message : ''
                // })
                //
                // // CARD CVC
                // let cardCvcRef = this.$refs['card-cvc-el']
                // let cardCvc = elements.create('cardCvc', {
                //     style: style,
                //     placeholder: 'Card CVC'
                // })
                // cardCvc.mount(cardCvcRef)
                // cardCvc.addEventListener('change', event => {
                //     this.$refs['card-cvc-errors'].textContent = event.error ? event.error.message : ''
                // })
-->
